"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M201.8,187.9v218.2h59.5V295c0-61.7,79.3-66.8,79.3,0v111.1h59.5V272c0-104.1-111.1-100.4-138.8-49.1v-35H201.8z"
  }), (0, _core.jsx)("ellipse", {
    cx: "132.5",
    cy: "128",
    rx: "34.7",
    ry: "35"
  }), (0, _core.jsx)("rect", {
    x: "102.8",
    y: "187.9",
    width: "59.5",
    height: "218.2"
  }));
};

exports.default = _default;